import LiveBidsService from "../LiveBidsService";

export default {
  namespaced: true,
  name: 'liveBids',
  state: {
    sale: {
      loading: false,
      saleInfo: {
        department: {}
      },
      activeLot: {
        vendor: {}
      },
      lots: []
    },
    unsoldLotModal: {
      show: false
    }
  },
  actions: {
    async getSaleInfo({commit}, {saleNo}) {
      commit('changeSaleLoading');
      let response = await LiveBidsService.getSale(saleNo);
      commit('changeSaleLoading');

      if (response.success) {
        commit('getSaleInfo', response.body)
      }

      return response;
    },
    activateLot({commit}, lot) {
      commit('activateLot', lot);
    },
    async markSold({commit}, payload) {
      let response = await LiveBidsService.updateLot(payload);
      if (response.success) {
        commit('markSold', response.body);
      }
      return response;
    },
    async markUnsold({commit}, payload) {
      let response = await LiveBidsService.updateLot(payload);
      if (response.success) {
        commit('markUnsold', response.body);
      }
      return response;
    },
    async updateActiveLotPreBid({state}, payload) {
      const index = state.sale.activeLot.pre_bids.findIndex(r => r.uuid === payload.uuid);
      state.sale.activeLot.pre_bids[index] = {...state.sale.activeLot.pre_bids[index], ...payload};
      state.sale.activeLot.pre_bids = [...state.sale.activeLot.pre_bids];
    },
    async updateLotPreBid({state}, payload) {
      const updatedLotIndex = state.sale.lots.findIndex(l => l.lot_no === payload.lot_no);
      const index = state.sale.lots[updatedLotIndex].pre_bids.findIndex(r => r.uuid === payload.uuid);
      state.sale.lots[updatedLotIndex].pre_bids[index] = {...state.sale.lots[updatedLotIndex].pre_bids, ...payload};
      state.sale.lots[updatedLotIndex].pre_bids = [...state.sale.lots[updatedLotIndex].pre_bids];
    },
    async addActiveLotPreBid({state}, payload) {
      state.sale.activeLot.pre_bids.unshift(payload)
    },
    async addLotPreBid({state}, payload) {
      const updatedLotIndex = state.sale.lots.findIndex(l => l.lot_no === payload.lot_no);
      state.sale.lots[updatedLotIndex].pre_bids.unshift(payload)
    },
    async showUnsoldLotModal({state}) {
      state.unsoldLotModal.show = true
    },
    async hideUnsoldLotModal({state}) {
      state.unsoldLotModal.show = false
    },
    async activeLotUpdated({state}, payload) {
      if (state.sale.activeLot.uuid !== payload.lot_uuid) {
        return false
      }

      let response = await LiveBidsService.getSale(state.sale.saleInfo.sale_no, {lot_uuid: state.sale.activeLot.uuid});
      if (!response.success) {
        return false
      }

      let responseLot = response.body.lots.find(l => l.uuid === state.sale.activeLot.uuid)
      if (!responseLot) {
        return false
      }

      const updatedLotIndex = state.sale.lots.findIndex(l => l.uuid === responseLot.uuid);
      state.sale.lots[updatedLotIndex] = responseLot
      state.sale.activeLot = responseLot
    }
  },
  mutations: {
    changeSaleLoading: state => state.sale.loading = !state.sale.loading,
    getSaleInfo: (state, sale) => {
      sale.lots = sale.lots.filter(l => l.status !== 'withdrawn');

      let lot = sale.lots.find(l => l.status === 'lotted');

      if (!lot) {
        lot = sale.lots.find(l => l.status === 'unsold' || l.status === 'sold');
      }

      state.sale.saleInfo = sale.auction;
      state.sale.lots = sale.lots;
      state.sale.activeLot = lot;
    },
    activateLot: (state, lot) => state.sale.activeLot = lot,
    markSold: (state, lot) => {
      const lotObject = state.sale.lots.find(l => l.uuid === lot.uuid);
      lotObject.status = 'sold';
      lotObject.buyer = lot.buyer;
      lotObject.vendor = lot.vendor;
      state.sale.lots = [...state.sale.lots];
    },
    markUnsold: (state, lot) => {
      const lotObject = state.sale.lots.find(l => l.uuid === lot.uuid);
      lotObject.status = 'unsold';
      lotObject.buyer = {};
      lotObject.vendor = lot.vendor;
      lotObject.last_bid_amount = lot.last_bid_amount;
      lotObject.hammer_price = null;
      lotObject.paddle_number = null;
      state.sale.lots = [...state.sale.lots];
    }
  },
  modules: {}
}
